// extracted by mini-css-extract-plugin
var _1 = "ra-category";
var _2 = "ra-category-title";
export { _1 as "categoryCls", _2 as "categoryTitleCls" }
